export const CLOSE_EOD_SHIPMENTS = 'CLOSE_EOD_SHIPMENTS';
export const closeEODShipments = ({ payload, onSuccess, onError }) => {
  return {
    type: CLOSE_EOD_SHIPMENTS,
    payload,
    onError,
    onSuccess,
  };
};

export const CLOSE_EOD_SHIPMENTS_SUCCESS = 'CLOSE_EOD_SHIPMENTS_SUCCESS';
export const closeEODShipmentsSuccess = ({ pusherData, messageGuid }) => {
  return {
    type: CLOSE_EOD_SHIPMENTS_SUCCESS,
    pusherData,
    messageGuid,
  };
};

export const CLOSE_EOD_SHIPMENTS_FAILURE = 'CLOSE_EOD_SHIPMENTS_FAILURE';
export const closeEODShipmentsFailure = ({ error, messageGuid = '' }) => {
  return {
    type: CLOSE_EOD_SHIPMENTS_FAILURE,
    error,
    messageGuid,
  };
};
